import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { v4 } from 'uuid';

import { ScheduledJob, ScheduledJobStatus, ScheduledJobType } from '@shure/cloud/shared/models/devices';

import { ScheduledJobsApiService } from '../api/scheduled-jobs-api.service';

@Injectable({ providedIn: 'root' })
export class SysApiScheduledJobsService implements ScheduledJobsApiService {
	public scheduledJobs = new BehaviorSubject<ScheduledJob[]>([]);
	private scheduledJobsMap = new Map<string, ScheduledJob>();
	private loadingInProgress = new BehaviorSubject<boolean>(false);

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	constructor() {}

	public loadingInProgress$(): Observable<boolean> {
		return this.loadingInProgress.asObservable();
	}

	public refresh(): void {
		if (this.loadingInProgress.getValue() === true) return;
		this.loadingInProgress.next(true);
		setTimeout(() => {
			this.loadingInProgress.next(false);
		}, 500);
		this.addFakeJob();
	}

	public scheduledJobs$(): Observable<ScheduledJob[]> {
		return this.scheduledJobs.asObservable();
	}

	public scheduledJobsCount$(): Observable<number> {
		return this.scheduledJobs$().pipe(map((jobs) => jobs.length));
	}

	// these are all temporary method to generate fake data
	private addFakeJob(): void {
		const jobIndex = this.scheduledJobsMap.size + 1;
		const newJob: ScheduledJob = {
			id: btoa(`job-${jobIndex}`),
			jobId: v4().split('-')[4].toUpperCase(),
			jobName: `Scheduled Job ${jobIndex}`,
			jobType: ScheduledJobType.FirmwareUpdate,
			jobStatus: this.scheduledJobStatus(jobIndex),
			deviceCount: Math.floor(Math.random() * 100 + 1),
			executeAt: this.generateRandomExecuteTime(),
			createdBy: v4(),
			updatedBy: v4(),
			createdAt: new Date(),
			updatedAt: new Date()
		};
		this.scheduledJobsMap.set(newJob.id, newJob);
		this.scheduledJobs.next([...this.scheduledJobsMap.values()]);
	}

	private generateRandomExecuteTime(): Date {
		const now = new Date();
		const currentTime = now.getTime();

		// Random time within the next 2 hours (in milliseconds)
		const twoHours = 2 * 60 * 60 * 1000;
		const randomTimeOffset = Math.random() * twoHours;

		// Create the random date
		const randomDate = new Date(currentTime + randomTimeOffset);

		// Set minutes to either 0 (top of hour) or 30 (bottom of hour)
		const minutes = Math.random() < 0.5 ? 0 : 30;
		randomDate.setMinutes(minutes);
		randomDate.setSeconds(0);
		randomDate.setMilliseconds(0);

		return randomDate;
	}

	private scheduledJobStatus(i: number): ScheduledJobStatus {
		switch (i % 6) {
			case 0:
				return ScheduledJobStatus.Pending;
			case 1:
				return ScheduledJobStatus.Executing;
			case 2:
				return ScheduledJobStatus.Completed;
			case 3:
				return ScheduledJobStatus.Failed;
			case 4:
				return ScheduledJobStatus.Cancelled;
			case 5:
			default:
				return ScheduledJobStatus.Missed;
		}
	}
}
